import React from 'react';
import './Divider.css';
import './Stack.css';
import '../styles/styles.css'


interface DividerProps {
  /** Indicates whether spacing is applied to it or not. */
  nested?: boolean;

  /** This extends the divider's right edge to take up the space of a container. */
  extendLeft?: boolean;

  /** This extends the divider's left edge to take up the space of a container. */
  extendRight?: boolean;

  /** When true, the divider will display vertically. */
  vertical?: boolean;
}

const Divider: React.FC<DividerProps> = ({ nested = false, extendLeft, extendRight, vertical }) => {
  const className = `divider${nested ? ' nested' : ''}${extendLeft ? ' extend-left' : ''}${extendRight ? ' extend-right' : ''}${vertical ? ' vertical width-hug' : ''}`;
  return <div className={className} />;
};

/**
 * # Divider
 * Divides sections by creating a vertical or horizontal line.
 * 
 * [See Documentation](https://themeable.systems/documentation)
 * 
 * ---
 * 
 * ### Style props:
 * `vertical`: Boolean which makes the divider display vertically, rather than horizontally.
 * 
 * `spacing`: Boolean. Really meant for building components and should be used sparingly. Removes baked-in spacing.
 * 
 * `extendRight`: Boolean. This extends the divider's right edge to take up the space of a container.
 * 
 * `extendLeft`: Boolean. This extends the divider's left edge to take up the space of a container.
 */

export { Divider };
